module.exports = __webpack_public_path__ + "static/media/r-md15.153d0012.png";